import instance from '../../../../api/axios'
import { Whiteboard, WhiteboardRaw } from '../../../Whiteboard/types/whiteboard'
import {
  CreateProtocol,
  ProtocolItem,
  ProtocolItemRaw,
} from '../types/protocol'

const parseWhiteboard = (whiteboard: WhiteboardRaw): Whiteboard => ({
  ...whiteboard,
  excalidrawElement: whiteboard.excalidrawElement
    ? JSON.parse(whiteboard.excalidrawElement)
    : [],
  excalidrawFiles: whiteboard.excalidrawFiles
    ? JSON.parse(whiteboard.excalidrawFiles)
    : undefined,
})

const parseProtocol = (protocol: ProtocolItemRaw): ProtocolItem => ({
  ...protocol,
  whiteboards: (protocol.whiteboards || []).map(parseWhiteboard),
  documents: protocol.documents || [],
})

export const loadProtocols = async (): Promise<ProtocolItem[]> => {
  const response = await instance.get<ProtocolItemRaw[]>('/protocols')
  return (response.data || []).map(parseProtocol)
}

export const createProtocol = async (
  payload: CreateProtocol,
): Promise<ProtocolItem> => {
  const response = await instance.post<ProtocolItemRaw>('/protocols', payload)
  return parseProtocol(response.data)
}

export const modifyProtocol = async (
  payload: ProtocolItem,
): Promise<ProtocolItem> => {
  const response = await instance.put<ProtocolItemRaw>('/protocols', {
    id: payload.id,
    name: payload.name,
    description: payload.description,
    createdAt: payload.createdAt,
    createdBy: payload.createdBy,
    status: payload.status,
    isPublic: payload.isPublic,
  })
  return parseProtocol(response.data)
}

export const removeProtocol = async (id: string): Promise<string> => {
  const response = await instance.delete(`/protocols/${id}`)
  return response.data
}
